import { MockSealLookupApi } from './sealLookupMock';

// The one adapter the Seal Lookup page talks to: { meta(), search(URLSearchParams) }.
// Swap for an HTTP adapter calling the portal's own /api/seal-lookup/{meta,search} route once the
// Pimcore portal endpoint exists (b2b-portal-seal-lookup.md section 8). Never call Pimcore from the browser.
export const sealLookupApi = new MockSealLookupApi();
